import React, { Component } from 'react';
import Tile from '../components/tile';
import Video from '../components/video';
class VanderCook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playVideo: false,
      videoUrl: '',
      subtitles: 'captions_VanderCook.vtt',
      images: [
        {
          url:  'vandercook.jpg',
          video: 'VANDERCOOK',
          subtitles: undefined,
          subtitlesIrish: undefined,
          prevText: "",
          nextText: "Next Printer"
        },
         {
          url:  'vandercook.jpg',
          video: 'freddie-snow',
          subtitles: 'captions_Vandercook.vtt',
          subtitlesIrish: 'captions_Irish_Vandercook.vtt',
          prevText: "Previous Printer",
          nextText: ""
        },
       
      ],
      mediaIndex: 0
    };
  }
  
  playVideo(index) {
    this.setState({ playVideo: true, mediaIndex: index });

    var elem = document.body;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      document.body.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  closeVideo() {
    this.setState({ playVideo: false, mediaIndex: 0 });

  }

  nextVideo() {
   if( this.state.mediaIndex < this.state.images.length -1 ){
    this.setState({mediaIndex: this.state.mediaIndex + 1})
   }
    else{
      this.setState({ playVideo: false, mediaIndex: 0 });
    }
  }

  prevVideo() {
    if( this.state.mediaIndex > 0 )
    this.setState({mediaIndex: this.state.mediaIndex - 1})
  }
  render() {
    const mediaIndex = this.state.mediaIndex;
    const text =
    'Up until the early twentieth century, proofs were being pulled from hand presses or galley presses. Robert O. Vandercook developed a more sophisticated proofing press in 1909 allowing for higher quality proofs.   In 2018, to commemorate the votes for women in Ireland, the Museum reproduced a replica suffrage poster in collaboration with the National Library of Ireland and graphic artist Mary Plunkett on this press. The limited edition prints are available for sale in the gift shop and online.';
    return (
      <div className="shaw vandercook">
        {this.state.playVideo ? (
          <Video
            onClose={() => this.closeVideo()}
            onNext={() => this.nextVideo() }
            playNext={() => this.nextVideo()}
            nextText={this.state.images[mediaIndex].nextText}
            noLast={this.state.mediaIndex === this.state.images.length -1}
            noFirst={this.state.mediaIndex === 0}
            onPrev={() => this.prevVideo()}
            subtitlesIrish={this.state.images[mediaIndex].subtitlesIrish}
            videoUrl={this.state.images[mediaIndex].video}
            subtitles={this.state.images[mediaIndex].subtitles}
            imageUrl={this.state.images[mediaIndex].url}
            nextText={this.state.images[mediaIndex].nextText}
            prevText={this.state.images[mediaIndex].prevText}
          />
        ) : (
          <div style={{flex: 1}}>
            <Tile
              bg={'vandercook.jpg'}
              titleImage={'Vandercook.png'}
              onPlay={(index) => this.playVideo(index)}
              title={'Vandercook Proofing Press, Printer - Freddie Snowe'}
              subTitle={
                '- Freddie Snowe'
              }
              bold={'Printer'}
              text={text}
            />
            </div>
        )}
      </div>
    );
  }
}

export default VanderCook;



// WEBPACK FOOTER //
// ./src/pages/VanderCook.js